'use client';

import React, { ReactNode } from 'react';
import { useUser } from '@/features/auth/shared/hooks/use-user';

type UserAuthSwitchProps = {
  authenticated: ReactNode;
  notAuthenticated: ReactNode;
  loading?: ReactNode;
  preferNotAuthenticatedWhileLoading?: boolean;
};

export function UserAuthSwitch({
  authenticated,
  notAuthenticated,
  loading = null,
  preferNotAuthenticatedWhileLoading = false,
}: UserAuthSwitchProps) {
  const userSession = useUser();

  if (userSession.authenticatedUser) {
    return <>{authenticated}</>;
  }
  if (userSession.loading) {
    return <>{preferNotAuthenticatedWhileLoading ? notAuthenticated : loading}</>;
  }
  return <>{notAuthenticated}</>;
}
